<template>
    <career-youth-programs-template-page :show-filter="false" :show-vacancies="false" hero-title="Прокачай<br>карьеру в ИНК!" class="u-pt-2xl"/>
</template>

<script setup>
import CareerYouthProgramsTemplatePage from './template/CareerYouthProgramsTemplatePage.vue'
</script>

<style lang="scss">
.career-youth-programs-pupils-page {}
</style>
